import { render, staticRenderFns } from "./UserVerificationForm.vue?vue&type=template&id=7431cfa3"
import script from "./UserVerificationForm.vue?vue&type=script&lang=js"
export * from "./UserVerificationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports